import { render, staticRenderFns } from "./AnalitikaTroskovaOdrzavanja.vue?vue&type=template&id=2d513f62&"
import script from "./AnalitikaTroskovaOdrzavanja.vue?vue&type=script&lang=ts&"
export * from "./AnalitikaTroskovaOdrzavanja.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports